<div>
  <div>
    {{ issue.message }}
  </div>

  <div class="padding-top" *ngIf="issue.originalErrorMessage">
    <div class="error-label">{{ originalErrorHeaderText }}</div>
    <div class="command-block">
      <button
        class="copy-btn"
        [copy-clipboard]="issue.originalErrorMessage"
        (copied)="copyFeedback.onCopied('originalError')"
      >
        <i
          class="fa-utility fa-semibold"
          [class.fa-copy]="!copyFeedback.copiedStates['originalError']"
          [class.fa-check]="copyFeedback.copiedStates['originalError']"
        ></i>
        {{ copyFeedback.copiedStates['originalError'] ? 'Copied!' : 'Copy' }}
      </button>
      <pre><code>{{ issue.originalErrorMessage }}</code></pre>
    </div>
  </div>

  <!-- Scripts -->
  <div
    class="padding-top scripts-section"
    [class.has-tabs]="scriptLanguages.length > 1"
    *ngIf="issue.scripts && scriptLanguages.length > 0"
  >
    <app-tabs
      *ngIf="scriptLanguages.length > 1"
      [tabs]="scriptTabs"
      [useRouting]="false"
      [activeTabIndex]="activeScriptTabIndex"
      (tabChange)="onScriptTabChange($event)"
    ></app-tabs>
    <div class="command-block">
      <button
        class="copy-btn"
        [copy-clipboard]="activeScriptContent"
        (copied)="copyFeedback.onCopied('script-' + activeScriptLanguage)"
      >
        <i
          class="fa-utility fa-semibold"
          [class.fa-copy]="!copyFeedback.copiedStates['script-' + activeScriptLanguage]"
          [class.fa-check]="copyFeedback.copiedStates['script-' + activeScriptLanguage]"
        ></i>
        {{ copyFeedback.copiedStates['script-' + activeScriptLanguage] ? 'Copied!' : 'Copy' }}
      </button>
      <pre><code>{{ activeScriptContent }}</code></pre>
    </div>
  </div>

  <div class="padding-top" *ngIf="issue.promptToUpdateTemplates">
    <a href="" (click)="showAccessDialog($event)">Click here to update your access templates</a>
  </div>

  <div class="padding-top" *ngIf="issue.additionalDetailsUrl && issue.additionalDetailsTitle">
    <a [href]="issue.additionalDetailsUrl" target="_blank">
      {{ issue.additionalDetailsTitle }}
    </a>
  </div>
</div>

<modal-dialog #updateAccessDialog [dialogTemplate]="updateAccessDialogTemplate"></modal-dialog>

<ng-template #updateAccessDialogTemplate>
  <update-access-dialog
    [applicationType]="applicationType"
    [sourceEndpointUri]="sourceEndpointUri"
    [targetEndpointUri]="targetEndpointUri"
    [identityProviderId]="identityProviderId"
    (done)="dismissAccessDialog()"
    (cancel)="dismissAccessDialog()"
  ></update-access-dialog>
</ng-template>
